// localStorage封装
import CryptoJS from 'crypto-js'

// 从环境变量获取加密密钥（安全改进：避免硬编码）
const SECRET_KEY = import.meta.env.VITE_STORAGE_SECRET_KEY || 'default_fallback_key'

if (!import.meta.env.VITE_STORAGE_SECRET_KEY) {
  console.warn('警告：未设置环境变量 VITE_STORAGE_SECRET_KEY，使用默认密钥（不安全）')
}

// 加密函数
export const encrypt = (data) => {
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString()
  } catch (error) {
    console.error('加密失败:', error)
    return null
  }
}

// 解密函数
export const decrypt = (ciphertext) => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY)
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
  } catch (error) {
    console.error('解密失败:', error)
    return null
  }
}

// 存储键名常量
export const STORAGE_KEYS = {
  USER_INFO: 'user_info',
  TOKEN: 'h5_token',  // Cookie存储key，避免与admin-ui冲突
  SIGN_RECORD: 'sign_record',
  WITHDRAW_APPLICATIONS: 'withdraw_applications',
  REMEMBER_PASSWORD: 'remember_password'
}

// Cookie 操作函数（企微环境下更可靠）
export const setCookie = (name, value, days = 30) => {
  try {
    const expires = new Date()
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`
    return true
  } catch (error) {
    console.error('设置Cookie失败:', error)
    return false
  }
}

export const getCookie = (name) => {
  try {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length))
      }
    }
    return null
  } catch (error) {
    console.error('获取Cookie失败:', error)
    return null
  }
}

export const removeCookie = (name) => {
  try {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
    return true
  } catch (error) {
    console.error('删除Cookie失败:', error)
    return false
  }
}

// 设置本地存储
export const setStorage = (key, value) => {
  try {
    const data = typeof value === 'object' ? JSON.stringify(value) : value
    localStorage.setItem(key, data)
    return true
  } catch (error) {
    console.error('存储失败:', error)
    return false
  }
}

// 获取本地存储
export const getStorage = (key, defaultValue = null) => {
  try {
    const data = localStorage.getItem(key)
    if (data === null) return defaultValue
    // 尝试解析JSON
    try {
      return JSON.parse(data)
    } catch {
      // 不是JSON格式，直接返回
      return data
    }
  } catch (error) {
    console.error('获取存储失败:', error)
    return defaultValue
  }
}

// 删除本地存储
export const removeStorage = (key) => {
  try {
    localStorage.removeItem(key)
    return true
  } catch (error) {
    console.error('删除存储失败:', error)
    return false
  }
}

// 清空本地存储
export const clearStorage = () => {
  try {
    localStorage.clear()
    return true
  } catch (error) {
    console.error('清空存储失败:', error)
    return false
  }
}

// 获取用户信息
export const getUserInfo = () => {
  return getStorage(STORAGE_KEYS.USER_INFO, {})
}

// 设置用户信息
export const setUserInfo = (userInfo) => {
  return setStorage(STORAGE_KEYS.USER_INFO, userInfo)
}

// 获取token（优先从cookie获取，兼容localStorage）
export const getToken = () => {
  // 优先从 cookie 获取（企微环境更可靠）
  const cookieToken = getCookie(STORAGE_KEYS.TOKEN)
  if (cookieToken) {
    // 同步到 localStorage
    setStorage(STORAGE_KEYS.TOKEN, cookieToken)
    return cookieToken
  }
  // 回退到 localStorage
  return getStorage(STORAGE_KEYS.TOKEN)
}

// 设置token（同时存储到cookie和localStorage）
export const setToken = (token) => {
  // 存储到 cookie（企微环境更可靠）
  setCookie(STORAGE_KEYS.TOKEN, token, 30)
  // 同时存储到 localStorage
  return setStorage(STORAGE_KEYS.TOKEN, token)
}

// 移除token（同时清除cookie和localStorage）
export const removeToken = () => {
  removeCookie(STORAGE_KEYS.TOKEN)
  return removeStorage(STORAGE_KEYS.TOKEN)
}


// 获取记住的密码信息
export const getRememberPassword = () => {
  const encryptedData = getStorage(STORAGE_KEYS.REMEMBER_PASSWORD, null)
  if (encryptedData) {
    return decrypt(encryptedData)
  }
  return null
}

// 设置记住的密码信息
export const setRememberPassword = (passwordInfo) => {
  if (passwordInfo) {
    // 只加密存储必要的信息，避免存储过多数据
    const encryptedData = encrypt({
      account: passwordInfo.account,
      password: passwordInfo.password
    })
    return setStorage(STORAGE_KEYS.REMEMBER_PASSWORD, encryptedData)
  } else {
    return removeStorage(STORAGE_KEYS.REMEMBER_PASSWORD)
  }
}
